import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';
import PageHeader from 'components/common/PageHeader';

const ListVacancies = () => {
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/vacancies/list`
        );
        console.log(response.data);
        setVacancies(response.data);
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      } finally {
        console.log('finally');
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveDocument = async (id, title) => {
    if (
      window.confirm(`Are you sure you want to delete this Job Vacancy: ${title}?`)
    ) {
      try {
        setError(null);
        await axios.put(
          `${process.env.REACT_APP_API_URL}/vacancies/archive/id/${id}`
        );
        setVacancies(vacancies.filter((vacancy) => vacancy.id !== id));
        toast.success(`${title} Job Vacancy deleted successfully`, {
          theme: 'colored',
        });
      } catch (error) {
        setError(error.message);
      }
    }
  };

  return (
    <>
      <PageHeader title='Vacancies' description='' className='mb-3'></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope='col'>Title</th>
              <th scope='col'>Contact</th>
              <th scope='col'>Status</th>
              <th scope='col'>Closing Date</th>
              <th className='text-end' scope='col'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {vacancies.length > 0 &&
              vacancies.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Link to={`/vacancy/${item.id}`}>
                      {item.title}
                    </Link>
                  </td>
                  <td>{item.contact}</td>
                  <td>{item.status}</td>
                  <td>{item.closing_date}</td>
                  <td className='text-end'>
                    <Link to={`/vacancies/edit/${item.id}`}>
                      <ActionButton
                        icon='edit'
                        title='Edit'
                        variant='action'
                        className='p-0 me-2'
                      />
                    </Link>
                    <ActionButton
                    icon='trash-alt'
                    title='Delete'
                    variant='action'
                    className='p-0'
                    alt='Delete'
                    onClick={() => archiveDocument(item.id, item.title)}
                  />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListVacancies;